import { Component, OnInit } from '@angular/core';
import { UserService } from './shared/services/http/user/user.service';
import { AuthService } from './shared/services/http/auth/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{
  title = 'exam-management';
  hideLoader:boolean = false;
  constructor(private userService: UserService, private authService: AuthService) {}

  ngOnInit(): void {
    this.userService.hideLoader.subscribe((res:any)=>{
      this.hideLoader = res;
    });

    if (typeof window !== 'undefined') {
      const refCode = new URLSearchParams(window.location.search).get('ref');
      if (refCode) {
        this.authService.trackReferralClick(refCode).subscribe((res: any) => {
          if (res?.data?.rid) {
            localStorage.setItem('referral_id', res.data.rid);
          }
        });
      }
    }
  }
}
